import * as React from "react";

const SvgIcnConnectionError = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M12 16a2 2 0 110 4 2 2 0 010-4zm5.2-.764l-.74.764A5.185 5.185 0 0015 14.326l.001-1.23a6.197 6.197 0 012.2 2.14zM9 13.096v1.23a5.185 5.185 0 00-1.459 1.673l-.74-.764a6.197 6.197 0 012.198-2.14zM13 4v10h-2V4h2zm7.114 8.232l-.724.747a9.216 9.216 0 00-4.389-3.283V8.605a10.221 10.221 0 015.113 3.627zM9 8.604v1.091a9.216 9.216 0 00-4.39 3.283l-.723-.747A10.22 10.22 0 019 8.604zm14.001.654L22.28 10A13.237 13.237 0 0015 5.384V4.32c3.193.694 5.99 2.472 8.001 4.937zm-14-4.937L9 5.384A13.237 13.237 0 001.72 9.999L1 9.257c2.01-2.465 4.808-4.243 8-4.936z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnConnectionError;
